import type { CartAddressData } from 'services';

/** Resolves the post number from saved data or the pickup-point company field. */
export function getPostnummer(address: CartAddressData, pickupPoint: boolean): string {
  if (address.postNumber) {
    return address.postNumber;
  }

  return pickupPoint ? (address.company ?? '') : '';
}